import React, { useState } from "react";
import tw from "twin.macro";
import Slider from "react-slick";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading, Subheading } from "components/misc/Headings.js";
import { PrimaryLink as PrimaryLinkBase } from "components/misc/Links.js";
import { PrimaryButton } from "../misc/Buttons.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import { ReactComponent as ChevronLeftIcon } from "feather-icons/dist/icons/chevron-left.svg";
import { ReactComponent as ChevronRightIcon } from "feather-icons/dist/icons/chevron-right.svg";
import { ReactComponent as LocationIcon } from "feather-icons/dist/icons/map-pin.svg";

const Container = tw.div`relative`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const Column = tw.div` lg:last:mr-0`;

const ImageAndControl = tw.div`w-full lg:w-1/2 max-w-lg lg:max-w-none mx-auto lg:mx-0`;
const HeadingColumn = styled(Column)((props) => [
  tw`w-full lg:w-1/2`,
  props.textOnLeft ? tw`lg:order-first` : tw`lg:order-last lg:pl-12 lg:mr-0`,
]);

const PortfolioImageSlider = tw(Slider)`w-full m-auto `;
const ImageAndControlContainer = tw.div`relative outline-none `;
const Image = styled.div((props) => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded bg-cover bg-center h-80 sm:h-96 lg:h-144`,
]);

const ControlContainer = tw.div`absolute bottom-0 right-0 bg-gray-100 px-6 py-4 rounded-tl-3xl border`;
const ControlButton = styled(PrimaryButton)`
  ${tw`mx-3 rounded-full text-gray-100 p-2`}
  svg {
    ${tw`w-5 h-5`}
  }
`;

const ThreeColumn = tw.div`flex flex-wrap`;

const CardColumn = tw(Column)`w-full mx-auto mb-4 lg:mb-0 `;

const HeadingInfoContainer = tw.div`text-left mt-12 lg:mt-0  max-w-lg lg:max-w-none mx-auto lg:mx-0`;
const HeadingTitle = tw(SectionHeading)`mt-4 text-left leading-tight`;
const HeadingDescription = tw.p`text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100 mt-6`;

const CardText = tw.div`mt-4`;
const CardHeader = tw.div`flex justify-between items-center`;
const CardCompany = tw.div`text-primary-500 font-bold text-lg mt-4`;
const CardType = tw.div`font-semibold text-sm text-gray-600`;
const CardTitle = tw.h5`text-xl font-bold`;

const CardMeta = styled.div`
  ${tw`flex flex-row flex-wrap justify-start sm:items-center font-semibold tracking-wide text-gray-600 uppercase text-xs mt-3`}
`;

const CardMetaFeature = styled.div`
  ${tw`flex items-center mr-4 last:mr-0`}
  svg {
    ${tw`w-5 h-5 mr-1`}
  }
`;

export default ({
  subheading = "Our Portfolio",
  heading = (
    <>
      We've done some <span tw="text-primary-500">amazing projects.</span>
    </>
  ),
  description = "We helped clients to enhance their online store which directly increase the number of customers in theirs store.",
  linkText = "View all Projects",
  cardLinkText = "Read Case Study",
  textOnLeft = false,
  projectImage = [
    {
      imageSrc:
        "https://images.unsplash.com/photo-1512100356356-de1b84283e18?ixlib=rb-1.2.1&auto=format&fit=crop&w=1024&q=80",
    },
    {
      imageSrc:
        "https://images.unsplash.com/photo-1523952578875-e6bb18b26645?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1024&q=80",
    },
  ],
  projectDetails = [
    {
      imageSrc:
        "https://images.unsplash.com/photo-1512100356356-de1b84283e18?ixlib=rb-1.2.1&auto=format&fit=crop&w=1024&q=80",
      company: "MFZ Gym.",
      type: "Development",
      title: "GYM Member managment System",
      durationText: "",
      locationText: "Surat, India.",
      projectLink: null,
    },
  ],
}) => {
  // useState is used instead of useRef below because we want to re-render when sliderRef becomes available (not null)
  const [imageSliderRef, setImageSliderRef] = useState(null);
  const [textSliderRef, setTextSliderRef] = useState(null);
  return (
    <Container>
      <Content>
        <ThreeColumn>
          <ImageAndControl>
            <PortfolioImageSlider
              arrows={false}
              ref={setImageSliderRef}
              asNavFor={textSliderRef}
              fade={true}
            >
              {projectImage.map((testimonial, index) => (
                <ImageAndControlContainer key={index}>
                  <Image imageSrc={testimonial.imageSrc} />
                  <ControlContainer>
                    <ControlButton onClick={imageSliderRef?.slickPrev}>
                      <ChevronLeftIcon />
                    </ControlButton>
                    <ControlButton onClick={imageSliderRef?.slickNext}>
                      <ChevronRightIcon />
                    </ControlButton>
                  </ControlContainer>
                </ImageAndControlContainer>
              ))}
            </PortfolioImageSlider>
          </ImageAndControl>
          <HeadingColumn textOnLeft={textOnLeft}>
            <HeadingInfoContainer>
              <Subheading>{subheading}</Subheading>
              <HeadingTitle
                dangerouslySetInnerHTML={{ __html: heading }}
              ></HeadingTitle>
              {projectDetails.map((card, index) => (
                <CardColumn key={index}>
                  <CardText>
                    <CardHeader>
                      <CardType>{card.type}</CardType>
                    </CardHeader>
                    <CardMeta>
                      <CardMetaFeature>
                        <LocationIcon /> {card.locationText}
                      </CardMetaFeature>
                    </CardMeta>
                  </CardText>
                </CardColumn>
              ))}
              <HeadingDescription>{description}</HeadingDescription>
            </HeadingInfoContainer>
          </HeadingColumn>
        </ThreeColumn>
      </Content>
    </Container>
  );
};
